import {
  sanitizeEmailInput,
  sanitizePasswordInput,
  validateEmailValue,
  validatePasswordValue,
} from "./inputValidation";

export const REQUIRED_FIELDS_MESSAGE = "Заполните все обязательные поля";

export function validateLoginForm(data) {
  const errors = {};
  const emailCheck = validateEmailValue(data.email);

  if (emailCheck.error) {
    errors.email = emailCheck.error;
  }

  const passwordCheck = validatePasswordValue(data.password);
  if (passwordCheck.error) {
    errors.password = passwordCheck.error;
  }

  return errors;
}

export function validateRegForm(data) {
  const errors = {};
  const emailCheck = validateEmailValue(data.regLogin);

  if (emailCheck.error) {
    errors.regLogin = emailCheck.error;
  }

  const passwordCheck = validatePasswordValue(
    data.regPassword,
    "Придумайте пароль"
  );
  if (passwordCheck.error) {
    errors.regPassword = passwordCheck.error;
  }

  const confirmCheck = validatePasswordValue(
    data.confirmRegPassword,
    "Повторите пароль"
  );
  if (confirmCheck.error) {
    errors.confirmRegPassword = confirmCheck.error;
  } else if (
    data.regPassword &&
    data.confirmRegPassword &&
    sanitizePasswordInput(data.regPassword) !==
      sanitizePasswordInput(data.confirmRegPassword)
  ) {
    errors.confirmRegPassword = "Пароли не совпадают";
  }

  return errors;
}

export function validateResetEmailForm(email) {
  const errors = {};
  const emailCheck = validateEmailValue(email);

  if (emailCheck.error) {
    errors.email = emailCheck.error;
  }

  return errors;
}

export function validateNewPasswordForm(data) {
  const errors = {};
  const passCheck = validatePasswordValue(data.pass, "Введите новый пароль");
  if (passCheck.error) {
    errors.pass = passCheck.error;
  }

  const confirmCheck = validatePasswordValue(
    data.confirmPass,
    "Повторите пароль"
  );
  if (confirmCheck.error) {
    errors.confirmPass = confirmCheck.error;
  } else if (
    data.pass &&
    data.confirmPass &&
    sanitizePasswordInput(data.pass) !== sanitizePasswordInput(data.confirmPass)
  ) {
    errors.confirmPass = "Пароли не совпадают";
  }

  return errors;
}

export function validateChangePasswordForm(data) {
  const errors = {};

  if (!sanitizePasswordInput(data.currentPassword)) {
    errors.currentPassword = "Введите текущий пароль";
  }

  const newPassCheck = validatePasswordValue(
    data.newPassword,
    "Введите новый пароль"
  );
  if (newPassCheck.error) {
    errors.newPassword = newPassCheck.error;
  }

  const confirmCheck = validatePasswordValue(
    data.confirmPassword,
    "Повторите пароль"
  );
  if (confirmCheck.error) {
    errors.confirmPassword = confirmCheck.error;
  } else if (
    data.newPassword &&
    data.confirmPassword &&
    sanitizePasswordInput(data.newPassword) !==
      sanitizePasswordInput(data.confirmPassword)
  ) {
    errors.confirmPassword = "Пароли не совпадают";
  }

  return errors;
}

export { sanitizeEmailInput, sanitizePasswordInput };
